/* eslint-disable perfectionist/sort-objects -- keys are sorted semantically */
module.exports = {
  'mobile-sm': '320px',
  'mobile-md': '375px',
  mobile: '425px',
  tablet: '768px',
  desktop: '1024px',
  'desktop-lg': '1440px',
}
